<template>
  <div class="mobile_status_header flex flex-vertical-center">
    <div class="flex flex-grow flex-between flex-vertical-center">
      <h5 class="mobile_status_header--heading">{{ status.label }}</h5>

      <div class="mobile_status_header--counts">
        <template v-if="showRyg">
          <p :class="['status_record_count red', {'is-zero': recordCounts['redCount'] === 0}]">
            {{ recordCounts["redCount"] }}
          </p>
          <p :class="['status_record_count yellow', {'is-zero': recordCounts['yellowCount'] === 0}]">
            {{ recordCounts["yellowCount"] }}
          </p>
          <p :class="['status_record_count green', {'is-zero': recordCounts['greenCount'] === 0}]">
            {{ recordCounts["greenCount"] }}
          </p>
        </template>
        <p v-else :class="['status_record_count', {'is-zero': records.length === 0}]">{{ records.length }}</p>
      </div>
    </div>

    <button>
      <icon-default
        :icon="props.open ? 'collapse' : 'expand'"
        color="is-secondary"
      ></icon-default>
    </button>
  </div>
</template>

<script>
import dates from "../../../services/dates";

export default {
  name: "MobileStatusHeader",
  props: {
    status: {
      type: Object,
      required: true
    },
    records: {
      type: Array,
      required: true
    },
    showRyg: {
      type: Boolean,
      default: false,
    },
    props: {}
  },
  computed: {
    // records() {
    //   return this.$store.getters.pipelineRecords([this.status.id]);
    // },
    recordCounts() {
      let redCount = 0;
      let yellowCount = 0;
      let greenCount = 0;

      this.records.forEach((record) => {
        if (dates.isTodayOrInPast(record.active_status.red_at)) {
          redCount += 1;
        } else if (dates.isTodayOrInPast(record.active_status.yellow_at)) {
          yellowCount += 1;
        } else {
          greenCount += 1;
        }
      });

      return {
        "redCount": redCount,
        "yellowCount": yellowCount,
        "greenCount": greenCount,
      };
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.mobile_status_header {
  padding: 4px 0 4px 10px;

  &--heading {
    line-height: 1.3;
  }

  &--counts {
    flex: 0 0 64px;
    margin: 0 4px;
    text-align: right;
  }
}

.status_record_count {
  display: inline-block;
  margin-right: 3px;
  font-weight: bold;

  &.is-zero {
    opacity: 0.5;
  }

  &.red {
    color: $red;
  }

  &.yellow {
    color: $yellow;
  }

  &.green {
    color: $green;
  }
}
</style>
